<template>
  <div class="mx-sm-5">
    <confirm-modal
      :title="confirmModalData.title"
      :confirm-button="confirmModalData.confirmButton"
    >
      {{ confirmModalData.text }}
    </confirm-modal>
    <b-row class="mb-2 pt-4">
      <b-col cols="8" sm="9">
        <h5 class="font-weight-bold text-main m-0">{{ task.title }}</h5>
      </b-col>
      <b-col cols="4" sm="3" class="text-right" v-if="!inCoins">
        <i
          v-if="showButtons"
          class="material-icons-outlined align-middle p-1 mr-3 cursor"
          v-on:click="edit"
          >border_color</i
        >
        <i
          v-if="showButtons"
          class="material-icons-outlined align-middle p-1  cursor"
          v-on:click="tryDelete"
          >delete</i
        >
      </b-col>
    </b-row>
    <b-row class="my-3 py-2">
      <b-col cols="12">
        <div class="d-flex justify-content-end pb-3 border-main-bottom">
        </div>
      </b-col>
    </b-row>
    <div class="my-3 d-flex">
      <span
        class="text-capitalize mr-3 px-3 py-1 bg-secundary rounded-pill text-white"
        >{{ task.type_text }}</span
      >
      <span
        :class="`bg-pri-${task.priority.description.toLowerCase()}`"
        class="text-white px-3 py-1 d-flex align-items-center rounded-pill"
      >
        <i class="material-icons medium-icon mr-1">flag</i>
        <p class="d-inline-block m-0 text-capitalize">
          {{ task.priority.description }}
        </p>
      </span>
    </div>
    <b-row class="my-3 py-2">
      <b-col cols="6">
        <p class="m-0 text-left font-weight-bold">Class</p>
      </b-col>
      <b-col cols="6">
        <p class="m-0 text-right">{{ task.subject_name }}</p>
      </b-col>
    </b-row>

    <b-row v-if="task.project" class="my-3 py-2">
      <b-col cols="6">
        <p class="font-weight-bold text-left m-0">Project</p>
      </b-col>
      <b-col cols="6">
        <p class="m-0 text-right">{{ task.project }}</p>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <p class="font-weight-bold m-0">When is it due?*</p>
        <p class="small my-2">{{ getFormattedDate(task.due_date) }}</p>
      </b-col>
      <b-col cols="6" class="text-right">
        <span class="material-icons-outlined medium-icon">event_available</span>
        <p class="small my-2">{{ formatAMPM(task.due_date) }}</p>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <p class="font-weight-bold m-0">When will you do it?</p>
        <p class="small my-2">{{ getFormattedDate(task.start_date) }}</p>
      </b-col>
      <b-col cols="6" class="text-right">
        <span class="material-icons-outlined medium-icon">today</span>
        <p class="small my-2">{{ formatAMPM(task.start_date) }}</p>
      </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <p class="text-uppercase text-main m-0 small-icon">Repeat</p>
        <p class="text-capitalize">{{ task.repeat_text }}</p>
      </b-col>
    </b-row>
    <b-row v-if="task.notification_type != 1" class="my-2">
      <b-col cols="6">
        <p class="text-uppercase text-main m-0 small-icon">Notification</p>
        <p>{{ task.notification_text }}</p>
      </b-col>
      <b-col cols="6" v-if="task.notification_type == 4 && task.notification_date">
        <p class="text-uppercase text-main m-0 small-icon">Notification time</p>
        <p>{{ formatAMPMHour(task.notification_date) }}</p>
      </b-col>
    </b-row>
    <b-row class="py-2" v-if="task.description">
      <b-col cols="12">
        <p class="text-uppercase text-main m-0 small-icon">Notes</p>
        <p class="text-break">{{ task.description }}</p>
      </b-col>
    </b-row>
    <b-row v-if="task.attachment" class="align-items-center pb-4">
      <b-col cols="12" class="text-truncate">
        <p class="text-uppercase text-main m-0 small-icon">Attach file</p>
        <b-img
          fluid
          :src="task.attachment"
          class="fit-image-horizontal attachment"
        ></b-img>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import { useSessionStore } from '@/common';
import { secondsToMiliseconds } from '@/plugins/utils';

import confirmModal from '@/common/components/modal/ConfirmModal';

export default {
  components: { confirmModal },
  props: {
    inCoins: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    Tid: {
      type: Number
    }
  },
  data() {
    return {
      showChronometer: this.showButtons,
      confirmModalData: {
        title: 'Confirm',
        text: 'text',
        confirmButton: () => {}
      }
    };
  },
  computed: {
    ...mapGetters('general', [
      'getFormattedDate',
      'formatAMPM',
      'formatAMPMHour'
    ]),
    sessionStorage() {
      return useSessionStore();
    },
    userIsAParent() {
      return this.sessionStorage.userIsAParent;
    },
    getTaskId() {
      let id = -1;
      if (this.$route.params.Tid) {
        id = this.$route.params.Tid;
      }
      if (this.$route.params.idRelated) {
        id = this.$route.params.idRelated;
      }
      if (this.Tid != null) {
        id = this.Tid;
      }
      if (id == -1) {
        id = 1;
      }
      return id;
    },
    task() {
      return store.getters['task/getTaskId'](this.getTaskId);
    },
    showWatch() {
      return Number(this.task.state) >= 4;
    },
    showActions() {
      return Number(this.task.state) === 4;
    }
  },
  methods: {
    ...mapActions('task', ['deleteTask', 'updateTimeInATask']),
    secondsToMiliseconds,
    edit() {
      this.$router.push({
        name: 'task-edit',
        query: {
          Tid: this.$route.params.Tid
        }
      });
    },
    tryDelete() {
      this.confirmModalData.title = 'Delete';
      this.confirmModalData.text = 'Do you want to delete this task?';
      this.confirmModalData.confirmButton = () => {
        try {
          this.deleteTask(this.getTaskId).then(() => {
            this.$router.go(-1);
          });
        } catch (error) {
          console.log(error);
        }
      };

      this.$bvModal.show('confirmModal');
    },
    convetTime(date) {
      let minutes = date % 60;
      let hours = (date - minutes) / 60;

      if (hours == 0) hours = null;
      else if (hours == 1) hours = hours + ' hour';
      else hours = hours + ' hours';

      if (minutes > 0) minutes = minutes + ' minutes';
      else minutes = null;

      if (hours == null) return minutes;
      else if (minutes == null) return hours;
      else return hours + ' ' + minutes;
    },
    handlePaused({ seconds }) {
      this.updateTimeInATask({ seconds, id: this.task.id });
    }
  },
  mounted() {
    if (this.userIsAParent) {
      this.showChronometer = false;
    }
  }
};
</script>
<style scoped>
img.attachment {
  width: 250px;
  margin: 0 auto;
}

/* @Overrited */
.material-icons-outlined {
  font-size: 22px;
}
</style>

